var map = {
	"./apple-laurel-da-DK.svg": 3621,
	"./apple-laurel-de-DE.svg": 97311,
	"./apple-laurel-en-GB.svg": 71309,
	"./apple-laurel-en-US.svg": 29141,
	"./apple-laurel-es-ES.svg": 20321,
	"./apple-laurel-es-MX.svg": 4162,
	"./apple-laurel-fr-FR.svg": 10597,
	"./apple-laurel-it-IT.svg": 13071,
	"./apple-laurel-nb-NO.svg": 94776,
	"./apple-laurel-nl-NL.svg": 25565,
	"./apple-laurel-pl-PL.svg": 5473,
	"./apple-laurel-pt-BR.svg": 75617,
	"./apple-laurel-pt-PT.svg": 47793,
	"./apple-laurel-sv-SE.svg": 804
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 87083;